import React, { Fragment } from "react";
import axios from "axios";
import { Form } from "informed";
import { toast } from "react-toastify";
import { InputTypeText } from "../elements";
import { API_URL } from "../../lib/const";
import ComponentWithToken from "../components/CompontentWithToken";

class ResetPassword extends ComponentWithToken {
  constructor(props) {
    super(props);
    this.handleSendRecoverEmail = this.handleSendRecoverEmail.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
  }

  state = {
    sending: false,
  };

  handleSendRecoverEmail(values) {
    const { history } = this.props;
    this.setState({ sending: true });
    axios
      .post(`${API_URL}/login/password_reset/`, values)
      .then(() => {
        toast.success("Email enviado com sucesso!");
        history.push("/login", {
          success: true,
          message: "Email enviado com sucesso",
        });
      })
      .catch(() => {
        this.setState({ sending: false });
        toast.error("Erro inesperado. Por favor, tente novamente.");
      });
  }

  handleChangePassword(values) {
    const { history } = this.props;
    if (values.password !== values.repeat_password) {
      toast.error("As senhas não coincidem");
      return;
    }
    if (values.password.length < 8) {
      toast.error("A senha deve conter no mínimo 8 caracteres");
      return;
    }
    this.setState({ sending: true });
    const data = {
      password: values.password,
      token: this.token,
    };
    axios
      .post(`${API_URL}/login/password_reset/confirm/`, data)
      .then(() => {
        toast.success("Senha alterada com sucesso");
        this.setState({ sending: false });
        history.push("/login", {
          success: true,
          message: "Senha alterada com sucesso",
        });
      })
      .catch(() => {
        this.setState({ sending: false });
        toast.error("Erro inesperado. Por favor, tente novamente.");
      });
  }

  render() {
    const { sending } = this.state;
    if (!this.token) {
      return (
        <Fragment>
          <div className="login-background">
            <Form
              className="login-card shadow"
              onSubmit={this.handleSendRecoverEmail}
            >
              <figure className="text-center mt-2">
                <img
                  src={require("../../assets/img/logo-green.svg")}
                  className="login-logo"
                  alt="notification"
                />
              </figure>
              <div className="group-input mt-3">
                <label style={{ fontWeight: "bold", color: "gray", marginTop: "10px" }}>
                  Insira o seu login e enviaremos um link de redefinição de
                  senha para seu email.
                </label>

                <InputTypeText
                  label="Email Cadastrado"
                  type="email"
                  field="email"
                  required
                />
                <button
                  type="submit"
                  className="btn btn-primary col-12 p-3"
                  disabled={sending}
                >
                  {sending ? "Enviando..." : "ENVIAR"}
                </button>
              </div>
            </Form>
          </div>
        </Fragment>
      );
    }
    return (
      <Fragment>
        <div className="login-background">
          <Form
            className="login-card shadow"
            onSubmit={this.handleChangePassword}
          >
            <figure className="text-center mt-2">
              <img
                src={require("../../assets/img/logo-green.svg")}
                className="login-logo"
                alt="notification"
              />
            </figure>

            <InputTypeText
              label="Nova senha"
              type="password"
              field="password"
              required
            />
            <InputTypeText
              label="Confirme sua senha"
              type="password"
              field="repeat_password"
              required
            />
            <button
              type="submit"
              className="btn btn-primary col-12 p-3"
              disabled={sending}
            >
              {sending ? "Enviando..." : "ENVIAR"}
            </button>
          </Form>
        </div>
      </Fragment>
    );
  }
}

export default ResetPassword;
